<div [ngClass]="type" class="md:h-[22px] md:!py-[2px] md:!px-2 md:table md:rounded-2xl md:!mr-2 md!leading-[22px]">
    <span class="font-inter !text-sm !font-medium !leading-[18px] table-cell align-middle">{{ item }}</span>
</div>
